const SUCCESS_FILE_STATUS = "SUCCESS_FILE_STATUS";
const LOADING_FILE_STATUS = "LOADING_FILE_STATUS";

export const FileStatusTypes = {
  SUCCESS_FILE_STATUS,
  LOADING_FILE_STATUS
};
